import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import App from './App';
import './index.css';

// 设置dayjs为中文
dayjs.locale('zh-cn');

// Ant Design主题配置
const theme = {
  token: {
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#fff',
      headerHeight: 64,
      headerPadding: '0 24px',
    },
    Card: {
      borderRadiusLG: 8,
      paddingLG: 24,
    },
    Button: {
      borderRadius: 6,
      controlHeight: 32,
    },
    Input: {
      borderRadius: 6,
      controlHeight: 32,
    },
    Select: {
      borderRadius: 6,
      controlHeight: 32,
    },
    DatePicker: {
      borderRadius: 6,
      controlHeight: 32,
    },
    Table: {
      borderRadiusLG: 6,
    },
    Tabs: {
      borderRadiusLG: 6,
    },
    Progress: {
      borderRadius: 100,
    },
    Tag: {
      borderRadiusSM: 4,
    },
    Tooltip: {
      borderRadius: 6,
    },
    Modal: {
      borderRadiusLG: 8,
    },
    Drawer: {
      borderRadiusLG: 8,
    },
    Notification: {
      borderRadiusLG: 8,
    },
    Message: {
      borderRadiusLG: 6,
    },
  },
};

// 创建根元素
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 渲染应用（开发环境不使用StrictMode，避免副作用双执行导致请求中止日志）
const isDev = Boolean((import.meta as any)?.env?.DEV);
const appTree = (
  <ConfigProvider 
    locale={zhCN} 
    theme={theme}
    componentSize="middle"
  >
    <AntdApp>
      <App />
    </AntdApp>
  </ConfigProvider>
);
root.render(isDev ? appTree : (<React.StrictMode>{appTree}</React.StrictMode>));